<div class="w-full h-full bg-[#232323] min-h-screen overflow-auto">
  <!-- Header -->
  <div class="px-8 md:px-16 pt-12 pb-6">
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 class="text-4xl font-extrabold text-white mb-2">Feedbacks</h1>
        <p class="text-lg text-white/70">
          {{ isVisualizacaoMode ? 'Visualize os feedbacks das imobiliárias' : 'Gerencie os feedbacks enviados e recebidos' }}
        </p>
      </div>
      <button
        *ngIf="podeEnviarFeedback"
        mat-flat-button
        class="!bg-[#E4811E] hover:!bg-[#d4751a] !text-white font-semibold px-6 py-2"
        (click)="abrirNovoFeedback()"
      >
        <mat-icon class="mr-2">add</mat-icon>
        Novo Feedback
      </button>
    </div>
  </div>

  <!-- Autocomplete de Imobiliárias (para ADM_SISTEMA e PARCEIRO) -->
  <div *ngIf="isVisualizacaoMode" class="px-8 md:px-16 pb-6">
    <mat-form-field appearance="outline" class="w-full max-w-md fuse-mat-dense fuse-mat-rounded">
      <mat-label>Selecione uma Imobiliária</mat-label>
      <input
        matInput
        [formControl]="imobiliariaCtrl"
        [matAutocomplete]="autoImob"
        (input)="filterImobiliarias($event)"
        placeholder="Digite para buscar..."
        class="text-white"
      />
      <mat-icon matSuffix class="text-white/50">search</mat-icon>
      <mat-autocomplete
        #autoImob="matAutocomplete"
        [displayWith]="displayImobiliariaFn"
        (optionSelected)="onImobiliariaSelected($event.option.value)"
      >
        <mat-option *ngFor="let imob of filteredImobiliarias" [value]="imob">
          {{ imob.nome }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <p *ngIf="selectedImobiliariaName" class="text-white/60 text-sm mt-2">
      Exibindo feedbacks da imobiliária: <span class="text-[#E4811E] font-medium">{{ selectedImobiliariaName }}</span>
    </p>
  </div>

  <!-- Tabs (para ADM_IMOBILIARIA e USUARIO_IMOBILIARIA) -->
  <div *ngIf="!isVisualizacaoMode" class="px-8 md:px-16 pb-6">
    <div class="flex gap-4 border-b border-zinc-700">
      <button
        class="px-4 py-3 text-sm font-medium transition-colors relative"
        [ngClass]="{'text-[#E4811E]': activeTab === 'recebidos', 'text-white/60': activeTab !== 'recebidos'}"
        (click)="activeTab = 'recebidos'"
      >
        Feedbacks Recebidos
        <span
          *ngIf="feedbacksRecebidos.length"
          class="ml-2 px-2 py-0.5 text-xs rounded-full"
          [ngClass]="{'bg-[#E4811E] text-black': activeTab === 'recebidos', 'bg-zinc-700 text-white/60': activeTab !== 'recebidos'}"
        >
          {{ feedbacksRecebidos.length }}
        </span>
        <div
          *ngIf="activeTab === 'recebidos'"
          class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#E4811E]"
        ></div>
      </button>
      <button
        class="px-4 py-3 text-sm font-medium transition-colors relative"
        [ngClass]="{'text-[#E4811E]': activeTab === 'enviados', 'text-white/60': activeTab !== 'enviados'}"
        (click)="activeTab = 'enviados'"
      >
        Feedbacks Enviados
        <span
          *ngIf="feedbacksEnviados.length"
          class="ml-2 px-2 py-0.5 text-xs rounded-full"
          [ngClass]="{'bg-[#E4811E] text-black': activeTab === 'enviados', 'bg-zinc-700 text-white/60': activeTab !== 'enviados'}"
        >
          {{ feedbacksEnviados.length }}
        </span>
        <div
          *ngIf="activeTab === 'enviados'"
          class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#E4811E]"
        ></div>
      </button>
    </div>
  </div>

  <!-- Conteúdo principal -->
  <div class="px-8 md:px-16 pb-12">
    <!-- Tabela de TODOS os Feedbacks da Imobiliária (para ADM_SISTEMA e PARCEIRO) -->
    <div *ngIf="isVisualizacaoMode && activeTab === 'todos'" class="bg-zinc-900 rounded-xl border border-zinc-800 overflow-hidden">
    <!-- Loading -->
    <div *ngIf="loadingImobiliaria" class="flex items-center justify-center py-16">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Placeholder antes de selecionar imobiliária -->
    <div *ngIf="!loadingImobiliaria && !selectedImobiliariaName" class="flex flex-col items-center justify-center py-16 text-white/50">
      <mat-icon class="text-5xl mb-4 !w-12 !h-12">business</mat-icon>
      <p class="text-lg">Selecione uma imobiliária</p>
      <p class="text-sm mt-1">Escolha uma imobiliária no campo acima para visualizar os feedbacks.</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loadingImobiliaria && selectedImobiliariaName && feedbacksImobiliaria.length === 0" class="flex flex-col items-center justify-center py-16 text-white/50">
      <mat-icon class="text-5xl mb-4 !w-12 !h-12">forum</mat-icon>
      <p class="text-lg">Nenhum feedback encontrado</p>
      <p class="text-sm mt-1">Esta imobiliária ainda não possui feedbacks registrados.</p>
    </div>

    <!-- Table -->
    <table *ngIf="!loadingImobiliaria && feedbacksImobiliaria.length > 0" class="w-full">
      <thead class="bg-zinc-800/50">
        <tr>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">De</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Para</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Tipo</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Mensagem</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Data</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let feedback of feedbacksImobiliaria"
          class="border-t border-zinc-800 hover:bg-zinc-800/50 cursor-pointer transition-colors"
          (click)="abrirDetalhe(feedback)"
        >
          <td class="px-6 py-4">
            <span class="text-white font-medium">
              {{ feedback.anonimoFlag ? 'Anônimo' : (feedback.nomeUsuarioCadastro || 'Usuário') }}
            </span>
          </td>
          <td class="px-6 py-4">
            <span class="text-white font-medium">
              {{ feedback.nomeUsuarioRecebido || 'Usuário' }}
            </span>
          </td>
          <td class="px-6 py-4">
            <div class="flex items-center gap-2">
              <mat-icon [class]="getTipoFeedback(feedback.tipoFeedbackId).cor" class="!text-lg">
                {{ getTipoFeedback(feedback.tipoFeedbackId).icone.includes('light-bulb') ? 'lightbulb' :
                   getTipoFeedback(feedback.tipoFeedbackId).icone.includes('triangle') ? 'warning' : 'star' }}
              </mat-icon>
              <span [class]="getTipoFeedback(feedback.tipoFeedbackId).cor">
                {{ getTipoFeedback(feedback.tipoFeedbackId).nome }}
              </span>
            </div>
          </td>
          <td class="px-6 py-4 max-w-xs">
            <p class="text-white/80 truncate">{{ feedback.texto }}</p>
          </td>
          <td class="px-6 py-4 text-white/60 text-sm whitespace-nowrap">
            {{ feedback.dataEnvio | date:'dd/MM/yyyy HH:mm' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Tabela de Feedbacks Recebidos (para ADM_IMOBILIARIA e USUARIO_IMOBILIARIA) -->
  <div *ngIf="!isVisualizacaoMode && activeTab === 'recebidos'" class="bg-zinc-900 rounded-xl border border-zinc-800 overflow-hidden">
    <!-- Loading -->
    <div *ngIf="loadingRecebidos" class="flex items-center justify-center py-16">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loadingRecebidos && feedbacksRecebidos.length === 0" class="flex flex-col items-center justify-center py-16 text-white/50">
      <mat-icon class="text-5xl mb-4 !w-12 !h-12">inbox</mat-icon>
      <p class="text-lg">Nenhum feedback recebido</p>
      <p class="text-sm mt-1">Quando alguém enviar um feedback para você, ele aparecerá aqui.</p>
    </div>

    <!-- Table -->
    <table *ngIf="!loadingRecebidos && feedbacksRecebidos.length > 0" class="w-full">
      <thead class="bg-zinc-800/50">
        <tr>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">De</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Tipo</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Mensagem</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Data</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let feedback of feedbacksRecebidos"
          class="border-t border-zinc-800 hover:bg-zinc-800/50 cursor-pointer transition-colors"
          (click)="abrirDetalhe(feedback)"
        >
          <td class="px-6 py-4">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-full bg-zinc-700 flex items-center justify-center">
                <mat-icon *ngIf="feedback.anonimoFlag" class="text-white/50">person_off</mat-icon>
                <span *ngIf="!feedback.anonimoFlag" class="text-white font-semibold text-sm">
                  {{ (feedback.nomeUsuarioCadastro || 'U')[0].toUpperCase() }}
                </span>
              </div>
              <span class="text-white font-medium">
                {{ feedback.anonimoFlag ? 'Anônimo' : (feedback.nomeUsuarioCadastro || 'Usuário') }}
              </span>
            </div>
          </td>
          <td class="px-6 py-4">
            <div class="flex items-center gap-2">
              <mat-icon [class]="getTipoFeedback(feedback.tipoFeedbackId).cor" class="!text-lg">
                {{ getTipoFeedback(feedback.tipoFeedbackId).icone.includes('light-bulb') ? 'lightbulb' :
                   getTipoFeedback(feedback.tipoFeedbackId).icone.includes('triangle') ? 'warning' : 'star' }}
              </mat-icon>
              <span [class]="getTipoFeedback(feedback.tipoFeedbackId).cor">
                {{ getTipoFeedback(feedback.tipoFeedbackId).nome }}
              </span>
            </div>
          </td>
          <td class="px-6 py-4 max-w-xs">
            <p class="text-white/80 truncate">{{ feedback.texto }}</p>
          </td>
          <td class="px-6 py-4 text-white/60 text-sm whitespace-nowrap">
            {{ feedback.dataEnvio | date:'dd/MM/yyyy HH:mm' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Tabela de Feedbacks Enviados (para ADM_IMOBILIARIA e USUARIO_IMOBILIARIA) -->
  <div *ngIf="!isVisualizacaoMode && activeTab === 'enviados'" class="bg-zinc-900 rounded-xl border border-zinc-800 overflow-hidden">
    <!-- Loading -->
    <div *ngIf="loadingEnviados" class="flex items-center justify-center py-16">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loadingEnviados && feedbacksEnviados.length === 0" class="flex flex-col items-center justify-center py-16 text-white/50">
      <mat-icon class="text-5xl mb-4 !w-12 !h-12">send</mat-icon>
      <p class="text-lg">Nenhum feedback enviado</p>
      <p class="text-sm mt-1">Clique em "Novo Feedback" para enviar seu primeiro feedback.</p>
    </div>

    <!-- Table -->
    <table *ngIf="!loadingEnviados && feedbacksEnviados.length > 0" class="w-full">
      <thead class="bg-zinc-800/50">
        <tr>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Para</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Tipo</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Mensagem</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Data</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Anônimo</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let feedback of feedbacksEnviados"
          class="border-t border-zinc-800 hover:bg-zinc-800/50 cursor-pointer transition-colors"
          (click)="abrirDetalhe(feedback)"
        >
          <td class="px-6 py-4">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-full bg-zinc-700 flex items-center justify-center">
                <span class="text-white font-semibold text-sm">
                  {{ (feedback.nomeUsuarioRecebido || 'U')[0].toUpperCase() }}
                </span>
              </div>
              <span class="text-white font-medium">
                {{ feedback.nomeUsuarioRecebido || 'Usuário' }}
              </span>
            </div>
          </td>
          <td class="px-6 py-4">
            <div class="flex items-center gap-2">
              <mat-icon [class]="getTipoFeedback(feedback.tipoFeedbackId).cor" class="!text-lg">
                {{ getTipoFeedback(feedback.tipoFeedbackId).icone.includes('light-bulb') ? 'lightbulb' :
                   getTipoFeedback(feedback.tipoFeedbackId).icone.includes('triangle') ? 'warning' : 'star' }}
              </mat-icon>
              <span [class]="getTipoFeedback(feedback.tipoFeedbackId).cor">
                {{ getTipoFeedback(feedback.tipoFeedbackId).nome }}
              </span>
            </div>
          </td>
          <td class="px-6 py-4 max-w-xs">
            <p class="text-white/80 truncate">{{ feedback.texto }}</p>
          </td>
          <td class="px-6 py-4 text-white/60 text-sm whitespace-nowrap">
            {{ feedback.dataEnvio | date:'dd/MM/yyyy HH:mm' }}
          </td>
          <td class="px-6 py-4">
            <span
              class="px-2 py-1 rounded-full text-xs font-medium"
              [ngClass]="{'bg-green-500/20 text-green-400': feedback.anonimoFlag, 'bg-zinc-700 text-white/60': !feedback.anonimoFlag}"
            >
              {{ feedback.anonimoFlag ? 'Sim' : 'Não' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Modal de Detalhes do Feedback -->
<div
  *ngIf="showDetalheModal && feedbackSelecionado"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
  (click)="fecharDetalhe()"
>
  <div
    class="bg-zinc-900 rounded-xl border border-zinc-700 w-full max-w-lg mx-4 overflow-hidden shadow-2xl"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-zinc-700">
      <div class="flex items-center gap-3">
        <mat-icon [class]="getTipoFeedback(feedbackSelecionado.tipoFeedbackId).cor" class="!text-2xl">
          {{ getTipoFeedback(feedbackSelecionado.tipoFeedbackId).icone.includes('light-bulb') ? 'lightbulb' :
             getTipoFeedback(feedbackSelecionado.tipoFeedbackId).icone.includes('triangle') ? 'warning' : 'star' }}
        </mat-icon>
        <h3 class="text-lg font-semibold text-white">{{ getTipoFeedback(feedbackSelecionado.tipoFeedbackId).nome }}</h3>
      </div>
      <button
        mat-icon-button
        class="!text-white/60 hover:!text-white"
        (click)="fecharDetalhe()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="px-6 py-5">
      <!-- Info cards -->
      <div class="grid grid-cols-2 gap-4 mb-5">
        <div class="bg-zinc-800 rounded-lg p-4">
          <p class="text-white/50 text-xs uppercase tracking-wider mb-1">De</p>
          <p class="text-white font-medium">
            {{ feedbackSelecionado.anonimoFlag ? 'Anônimo' : (feedbackSelecionado.nomeUsuarioCadastro || 'Usuário') }}
          </p>
        </div>
        <div class="bg-zinc-800 rounded-lg p-4">
          <p class="text-white/50 text-xs uppercase tracking-wider mb-1">Data</p>
          <p class="text-white font-medium">{{ feedbackSelecionado.dataEnvio | date:'dd/MM/yyyy' }}</p>
          <p class="text-white/60 text-sm">{{ feedbackSelecionado.dataEnvio | date:'HH:mm' }}</p>
        </div>
      </div>

      <!-- Mensagem -->
      <div class="bg-zinc-800 rounded-lg p-4">
        <p class="text-white/50 text-xs uppercase tracking-wider mb-2">Mensagem</p>
        <p class="text-white leading-relaxed whitespace-pre-wrap">{{ feedbackSelecionado.texto }}</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-zinc-700 flex justify-end">
      <button
        mat-flat-button
        class="!bg-zinc-700 !text-white"
        (click)="fecharDetalhe()"
      >
        Fechar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Novo Feedback -->
<div
  *ngIf="showNovoModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
  (click)="fecharNovoFeedback()"
>
  <div
    class="bg-zinc-900 rounded-xl border border-zinc-700 w-full max-w-5xl mx-4 max-h-[90vh] flex flex-col overflow-hidden shadow-2xl"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-zinc-700 flex-shrink-0">
      <h3 class="text-lg font-semibold text-white">Enviar Novo Feedback</h3>
      <button
        mat-icon-button
        class="!text-white/60 hover:!text-white"
        (click)="fecharNovoFeedback()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Content -->
    <form [formGroup]="novoFeedbackForm" (ngSubmit)="enviarFeedback()" class="px-6 py-5 overflow-y-auto flex-1">
      <div class="flex flex-col gap-5">
        <!-- Modelo (template) -->
        <div *ngIf="templates.length > 0" class="bg-amber-500/5 border border-amber-500/20 rounded-lg p-4">
          <div class="flex items-start gap-3 mb-3">
            <mat-icon class="text-amber-400 !text-xl flex-shrink-0 mt-0.5">auto_awesome</mat-icon>
            <div class="flex-1">
              <p class="text-white font-medium text-sm">Usar um modelo pronto</p>
              <p class="text-white/50 text-xs mt-0.5">Selecione um modelo para começar — você pode editar o texto depois.</p>
            </div>
          </div>
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Modelo de feedback</mat-label>
            <mat-select [value]="templateSelecionadoId" (selectionChange)="aplicarTemplate($event.value)">
              <mat-option [value]="null">— Em branco —</mat-option>
              <mat-option *ngFor="let t of templates" [value]="t.id">
                <span class="font-medium">{{ t.nome }}</span>
                <span class="text-white/50 text-xs ml-2" *ngIf="t.descricao">— {{ t.descricao }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Colaborador -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Colaborador</mat-label>
          <mat-select formControlName="usuarioRecebidoId">
            <mat-option *ngFor="let u of usuarios" [value]="u.id">{{ u.nome }}</mat-option>
          </mat-select>
          <mat-error *ngIf="novoFeedbackForm.get('usuarioRecebidoId')?.hasError('required')">
            Selecione um colaborador
          </mat-error>
        </mat-form-field>

        <!-- Tipo -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Tipo de Feedback</mat-label>
          <mat-select formControlName="tipoFeedbackId">
            <mat-select-trigger>
              <div class="flex items-center gap-2" *ngIf="novoFeedbackForm.get('tipoFeedbackId')?.value">
                <mat-icon [class]="getTipoFeedback(novoFeedbackForm.get('tipoFeedbackId')?.value).cor" class="!text-lg">
                  {{ getTipoFeedback(novoFeedbackForm.get('tipoFeedbackId')?.value).icone.includes('light-bulb') ? 'lightbulb' :
                     getTipoFeedback(novoFeedbackForm.get('tipoFeedbackId')?.value).icone.includes('triangle') ? 'warning' : 'star' }}
                </mat-icon>
                {{ getTipoFeedback(novoFeedbackForm.get('tipoFeedbackId')?.value).nome }}
              </div>
            </mat-select-trigger>
            <mat-option *ngFor="let tipo of tiposFeedback" [value]="tipo.id">
              <div class="flex items-center gap-2">
                <mat-icon [class]="tipo.cor" class="!text-lg">
                  {{ tipo.icone.includes('light-bulb') ? 'lightbulb' :
                     tipo.icone.includes('triangle') ? 'warning' : 'star' }}
                </mat-icon>
                {{ tipo.nome }}
              </div>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="novoFeedbackForm.get('tipoFeedbackId')?.hasError('required')">
            Selecione o tipo de feedback
          </mat-error>
        </mat-form-field>

        <!-- Mensagem -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Mensagem</mat-label>
          <textarea
            matInput
            rows="8"
            formControlName="texto"
            placeholder="Escreva seu feedback aqui..."
          ></textarea>
          <mat-hint>Mínimo de 10 caracteres</mat-hint>
          <mat-error *ngIf="novoFeedbackForm.get('texto')?.hasError('required')">
            A mensagem é obrigatória
          </mat-error>
          <mat-error *ngIf="novoFeedbackForm.get('texto')?.hasError('minlength')">
            Mínimo de 10 caracteres
          </mat-error>
        </mat-form-field>

        <!-- Anônimo -->
        <div class="flex items-center gap-3 bg-zinc-800 rounded-lg px-4 py-3">
          <mat-checkbox formControlName="anonimoFlag" color="accent"></mat-checkbox>
          <div>
            <p class="text-white font-medium">Enviar como anônimo</p>
            <p class="text-white/50 text-sm">Seu nome não será exibido no feedback</p>
          </div>
        </div>
      </div>
    </form>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-zinc-700 flex justify-end gap-3 flex-shrink-0">
      <button
        mat-flat-button
        class="!bg-zinc-700 !text-white"
        (click)="fecharNovoFeedback()"
        [disabled]="enviandoFeedback"
      >
        Cancelar
      </button>
      <button
        mat-flat-button
        class="!bg-[#E4811E] !text-black font-semibold"
        (click)="enviarFeedback()"
        [disabled]="enviandoFeedback || novoFeedbackForm.invalid"
      >
        <mat-spinner *ngIf="enviandoFeedback" diameter="20" class="mr-2"></mat-spinner>
        {{ enviandoFeedback ? 'Enviando...' : 'Enviar Feedback' }}
      </button>
    </div>
  </div>
</div>
